import * as React from "react";
import { useTranslation } from "react-i18next";
import GeneralWelcomeMetrics from "components/welcome/GeneralWelcomeMetrics";
import SecurityWelcomeMetrics from "./SecurityWelcomeMetrics";
const SecurityTabLabel = () => {
  const { t } = useTranslation("enterprise_security_app");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, t("welcome_metrics.tab_security"));
};
const securityWelcomeMetrics = [
  {
    id: "security",
    label: /* @__PURE__ */ React.createElement(SecurityTabLabel, null),
    component: SecurityWelcomeMetrics,
    isEnabled: ({ isValidSecurityLicense }) => isValidSecurityLicense
  }
];
const generalWelcomePageMetrics = [
  {
    component: () => /* @__PURE__ */ React.createElement(GeneralWelcomeMetrics, { topSourcesOnly: true }),
    isEnabled: ({ isValidSecurityLicense }) => isValidSecurityLicense
  }
];
const pluginExports = {
  welcomePageMetrics: securityWelcomeMetrics,
  "welcomePageMetrics.general": generalWelcomePageMetrics
};
export default pluginExports;
